// extracted by mini-css-extract-plugin
export default {"main":"App_main__ICThd","section_content":"App_section_content__XfOsR"};